<app-loading-spinner [loading]="loading"></app-loading-spinner>
<router-outlet></router-outlet>
